import { useQuery } from 'react-query';

import { getAvailableManager } from 'api/clients/getAvailableManager';

export const useGetAvailableManagers = () => {
  const { data, refetch, isLoading, isRefetching } = useQuery(['availableManagers'], () => getAvailableManager(), {
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading, isRefetching };
};

export default useGetAvailableManagers;
